<template>
  <div class="left-box">
    <div class="left-title d-aligncnter d-between">
      <div class="d-aligncnter">
        <!-- <img src="@/assets/img/cockpit/running.svg" style="margin-right: 8px" /> -->
        周锻炼人次
      </div>
      <div class="select-option d-aligncnter" style="position: relative">
        <el-date-picker
          v-model="currDate"
          type="date"
          placeholder="选择日期"
          :clearable="false"
          @change="DayDateChange"
          :picker-options="maxOptions"
        >
        </el-date-picker>
        <div style="font-size: 14px; position: absolute; right: 70px; top: 8px; z-index: -1">{{ endDate }}~</div>
      </div>
    </div>
    <div class="echarts">
      <div
        id="weekall"
        :style="{
          width: '512px',
          height: '242px',
          margin: '8px auto',
        }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['weekColleges', 'weekError', 'weekDate', 'weekData'],
  data() {
    return {
      echartsData: '',
      option1: '',
      currDate: '',
      endDate: '',
      maxDate: new Date(),
      maxOptions: {
        disabledDate(time) {
          if (time.getTime() > Date.now()) {
            return true
          } else {
            return false
          }
        },
      },
    }
  },
  watch: {
    monthData: {
      handler: function () {
        // this.option1.series[0].data = newVal
        var myChart1 = this.$echarts.init(document.getElementById('weekall'))
        myChart1.setOption(this.option1)

        // this.currDate = this.dayDate
        // console.log(this.currDate + 7 * 60 * 60 * 24 * 1000)
        // this.endDate = this.formatDate(this.currDate + 7 * 60 * 60 * 24 * 1000)
      },
      deep: true,
    },
    weekDate: {
      handler: function () {
        // this.option1.series[0].data = newVal
        this.currDate = this.weekDate
        console.log('???', this.currDate)
        // let d = new Date(this.weekDate.getTime() - 7 * 60 * 60 * 24 * 1000)
        let d = this.dateStringToTimestamp(this.weekDate) - 7 * 60 * 60 * 24 * 1000
        // this.endDate = this.formatDate(d)
        // let d = new Date(this.currDate).getTime() - 7 * 60 * 60 * 24 * 1000
        this.endDate = this.formatDate(d)
        console.log('???')
        // this.endDate = this.formatDate(this.currDate + 7 * 60 * 60 * 24 * 1000)
      },
      deep: true,
    },
  },
  mounted() {
    this.currDate = this.weekDate
    this.currDate = new Date(this.currDate)
    console.log('mounted:', this.weekDate)
    let d = this.currDate.getTime() - 7 * 60 * 60 * 24 * 1000
    // let d = new Date(this.currDate).getTime() - 7 * 60 * 60 * 24 * 1000
    this.endDate = this.formatDate(d)
    this.drawMonthData()
    window.onresize = () => {
      return (() => {
        this.drawMonthData()
      })()
    }
  },
  computed: {},
  methods: {
    dateStringToTimestamp(str) {
      return new Date(str).getTime()
    },
    DayDateChange() {
      let d = new Date(this.currDate.getTime() - 7 * 60 * 60 * 24 * 1000)
      this.endDate = this.formatDate(d)
      this.$emit('changeWeekDate', this.formatDate(this.currDate))
      // this.$emit('dayDateChange', this.currDate)
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    refresh(data1, data2) {
      console.log('refresh???month')
      //   this.drawMonthData()
      var myChart1 = this.$echarts.init(document.getElementById('weekall'))
      this.option1 = {
        legend: {
          data: ['有效人次'],
          right: '10%',
          top: '16',
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            color: '#ffffff66',
          },
        },
        tooltip: {},
        axisLabel: {
          color: '#ffffff66',
          fontSize: 12,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 30,
            formatter: function (value) {
              if (value.length > 4) {
                return value.slice(0, 3) + '...'
              }
              return value
            },
          },
          data: data2,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          minInterval: 50,
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)',
            },
          },
        },
        series: [
          {
            name: '有效人次',
            type: 'bar',
            stack: 'one',
            data: data1,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#009AFE' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },
    drawMonthData() {
      var myChart1 = this.$echarts.init(document.getElementById('weekall'))
      this.option1 = {
        legend: {
          data: ['有效人次'],
          right: '10%',
          top: '16',
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            color: '#ffffff66',
          },
        },
        tooltip: {},
        axisLabel: {
          color: '#ffffff66',
          fontSize: 12,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 30,
            formatter: function (value) {
              if (value.length > 4) {
                return value.slice(0, 3) + '...'
              }
              return value
            },
          },
          data: this.monthColleges,
          //   data: [
          //     '计算',
          //     '信电',
          //     '医学院',
          //     '外国语',
          //     '传媒',
          //     '法学院',
          //     '艺术',
          //     '怀卡托',
          //     '国土',
          //     '旅游',
          //     '马克思',
          //   ],
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          minInterval: 50,
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)',
            },
          },
        },
        series: [
          {
            name: '有效人次',
            type: 'bar',
            stack: 'one',
            // data: [100, 110, 80, 90, 110, 160, 100, 110, 80, 90, 110],
            data: this.monthData,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#009AFE' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
          //   {
          //     name: '异常人次',
          //     type: 'bar',
          //     stack: 'one',
          //     color: '#DE3831',
          //     // data: [10, 11, 8, 9, 11, 16, 10, 11, 8, 9, 11],
          //     data: this.monthError,
          //   },
        ],
      }
      myChart1.setOption(this.option1)
    },
  },
}
</script>
<style scoped lang="scss">
.left-box {
  //   width: calc(100% - 0px);
  width: calc(100% - 48px);
  //   width: 100%;
  margin-left: 24px;
  margin-top: 16px;

  .left-title {
    font-size: 22px;
    margin-bottom: 8px;
    // margin-left: 24px;
  }
}
.echarts {
  //   width: calc(100% - 48px);
  //   background: linear-gradient(
  //     180deg,
  //     rgba(26, 135, 95, 0.15) 0%,
  //     rgba(0, 122, 77, 0.24) 100%
  //   );
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 0%, rgba(0, 122, 77, 0) 100%);
  //   margin-left: 24px;
  //   height: calc(34vh - 46px);
  height: 222px;
}

.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0) !important;
}
.select-option ::v-deep .el-input__inner {
  //   border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
  width: 190px;
  border: none;
  padding-right: 0px !important;
  text-align: right;
}
.select-option ::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}
</style>
